





































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ChillIndex extends Vue {
  @Prop() forecast: any | null;
  dialog = false;
  chillIndex = "";
  mortlidad = "<13";
  riesgoClass = "sin-riesgo";
  riesgoStr = '';

  // clima
  precipitationTotal = 0;
  windIntensity = 0;
  windIntensityAvg2mts = 0;
  r = 0;

  data() {
    return {
      chillIndex: '',
    };
  }

  mounted() {
    this.calcular();
  }

  calcular() {
    /*
    Fuente: http://www.inia.uy/gras/Alertas-y-herramientas/Prevision%20Corderos
    CI = (11,7 + 3,1 × VV^0,5) × (40 - Ta) + 481 + R
    Dónde:
    CI: Pérdida potencial de calor (kJ/m2/h);
    VV: Velocidad media diaria del viento (m/s, a 2 metros sobre el nivel del suelo);
    Ta: Temperatura media diaria (ºC);
    R: 418 × (1-e^(-0,04x) siendo x = total diario de precipitación (mm)
    */
    this.precipitationTotal = this.forecast.precipitation;
    this.r = 418 * (1 - Math.exp(-0.04 * this.precipitationTotal));
    const tempAvg = (this.forecast.tempMin + this.forecast.tempMax) / 2; // promedio de la temp
    this.windIntensity = this.forecast.wind / this.forecast.counter; // promedio del viento
    this.windIntensityAvg2mts = this.windIntensity * ((2.0 / 10.0) ** 0.12);
    const _chillIndex = (11.7 + 3.1 * this.windIntensityAvg2mts ** 0.5) * (40 - tempAvg) + 481 + this.r;
    this.chillIndex = _chillIndex.toFixed(0);
    this.setRiesgoMortalidad();
  }

  setRiesgoMortalidad() {
    if (!this.chillIndex) {
      this.riesgoClass = ".sin-riesgo";
    } else {
      const nChillIndex = parseFloat(this.chillIndex);
      if (nChillIndex < 900) {
        this.mortlidad = "<13";
        this.riesgoClass = "sin-riesgo";
        this.riesgoStr = 'Sin riesgo';
      } else if (nChillIndex >= 900 && nChillIndex < 1000) {
        this.mortlidad = "13-28";
        this.riesgoClass = "bajo";
        this.riesgoStr = 'Bajo';
      } else if (nChillIndex >= 1000 && nChillIndex < 1100) {
        this.mortlidad = "28-51";
        this.riesgoClass = "medio";
        this.riesgoStr = 'Medio';
      } else if (nChillIndex >= 1100 && nChillIndex < 1200) {
        this.mortlidad = "51-73";
        this.riesgoClass = "alto";
        this.riesgoStr = 'Alto';
      } else if (nChillIndex >= 1200) {
        this.mortlidad = ">73";
        this.riesgoClass = "critico";
        this.riesgoStr = 'Crítico';
      }
    }
  }
}
